const links = [
  { label: 'O nas', href: 'http://www.perspektywy.pl/portal/index.php?option=com_content&view=article&id=28&Itemid=175' },
  { label: 'Patronaty', href: 'http://www.perspektywy.pl/portal/index.php?option=com_content&view=category&layout=blog&id=13&Itemid=124' },
  { label: 'Polityka Prywatności', href: 'http://www.perspektywy.pl/portal/index.php?option=com_content&view=article&id=16&Itemid=123' },
  { label: 'Znak jakości', href: 'http://www.perspektywy.pl/znakjakosci' },
  { label: 'Reklama', href: 'http://www.perspektywy.pl/reklama' },
  { label: 'Kontakt', href: 'http://www.perspektywy.pl/portal/index.php?option=com_content&view=article&id=23&Itemid=173' },
]

export default function Copyright() {
  return (
    <div className="copyrights py-1 px-0">
      <div className="container py-1">
        <div className="text-center">
          <h6 className="copyrights__logo pr-1 mb-1">© 2026 Perspektywy.pl</h6>
          <ul className="list-unstyled d-flex justify-content-center align-items-end px-0 m-0">
            {links.map((l) => (
              <li key={l.label} className="pr-1">
                <a href={l.href}>{l.label}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}